<template>
<div class="center-xs ">
  <h2>
    {{ $vuetify.lang.t('$vuetify.featureSelect.title') }}
  </h2>

  <div class="row around-xs">
    <v-btn v-if="build.features['selfcareGiftcardSupported']" xlarge class="col-xs-10 col-md-7 py-2" color="primary" @click="selectFeature('GiftCard', fetchGiftcardStore)">
      <v-icon large :color="btnTextColor" style="margin-right: 10px;">
        card_giftcard
      </v-icon>
      <span v-html="$vuetify.lang.t('$vuetify.common.giftcard')" :style="{ color: btnTextColor }"></span>
    </v-btn>

    <v-btn v-if="build.features['selfcareMembershipDepositSupported']" xlarge class="col-xs-10 col-md-7 py-2" color="primary" @click="selectFeature('Deposit', fetchDepositStore)">
      <img src="/giftcard/img/wallet-black.png" :style="{ marginRight: '10px', width: '28px', height: '28px', filter: btnTextColor === '#ffffff' ? 'brightness(0) invert(1)' : 'none' }" />
      <span v-html="$vuetify.lang.t('$vuetify.common.deposit')" :style="{ color: btnTextColor }"></span>
    </v-btn>
  </div>
</div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import { primaryTextColor } from '@/plugins/util';

export default {
  computed: {
    btnTextColor() { return primaryTextColor(this.$store.getters.getManifest?.meta?.primary) },
    ...mapGetters({
        build: 'getBuild',
        storeId: 'getStoreID'
    })
  },

  methods: {
    selectFeature(feature, func) {
      this.$parent.$parent.api = func
      this.setFeature(feature)

      this.$router.push({
        name: feature,
        params: { ...this.storeId }
      })
    },

    ...mapMutations([
      'setFeature'
    ]),
    ...mapActions([
      'fetchGiftcardStore',
      'fetchDepositStore'
    ])
  },

  mounted() {
    this.setFeature(null)
  }
}
</script>

<style scoped>
  h2 {
    margin: 10px auto 10px;
  }

  .col-md-5 {
    min-width: 230px !important;
  }
  .v-btn {
    font-size: 18px;
    text-align: left;

    height: 60px !important;

    margin: 10px auto;
  }

  a {
    text-decoration: none;
  }
</style>
